export const SITE = {
  name: "Austyle Plumbing",
  phone: "0452 538 075",
  tel: "tel:0452538075",
  email: "info@austyleplumbing.com",
  area: "Sydney & surrounding suburbs",
  years: 30,
  licence: "125342C",
  hoursSite: "Mon – Fri",
  hoursSiteTime: "7:00am – 3:30pm",
  hoursEmergency: "24/7 – blocked drains, jet blasting, CCTV & emergencies",
  instagram: "https://www.instagram.com/austyleplumbing/",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/24-hour-service", label: "24/7 Service", id: "24-7" },
  { to: "/projects", label: "Projects" },
  { to: "/areas", label: "Areas" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];
